import React, { Component } from "react";
import { BsyUtils } from "../../utils/Utils";
import _ from "lodash";

//整个组件处理逻辑的基础类
export class BsyWidget extends Component {
  constructor(props) {
    super();

    this.options = {
      ...{
        widgetName: "_widget_" + window.FX.STATIC.IDBase++,
        baseCls: "",
        customCls: null,
        enable: !0,
        visible: !0,
        invalidateType: "blank",
        value: null,
        height: 34,
        getContext: null,
        // lineHeight: 30,
      },
      ...props,
    };
    if (BsyUtils.isObjectEmpty(props.allowBlank)) {
      this.options.allowBlank = true;
    }
    this._beforeInit();
    this.options.cssName = this.options.baseCls + " " + this.options.widgetName;

    if (!this.isEnabled()) {
      if (!["subform","separator"].includes(this.options.type) )
        this.options.cssName += " bsy-ui-disable";
    }
    if (!this.isVisible()) {
      this.options.cssName += " bsy-ui-hidden";
    }

    if (this.options.customCls) {
      this.options.cssName += " " + this.options.customCls;
    }

    this.options.css = {};
    if (this.options.height) this.options.css.height = this.options.height;
    if (this.options.width) this.options.css.width = this.options.width;
    // this.options.css.lineHeight = this.options.lineHeight + 'px';
    this.state = {
      value: this.options.value,
    };
    this.value = this.options.value;
    this.element = React.createRef();
    this.uuid = BsyUtils.Ids24();
    //当前是否有焦点，用于虚拟dom刷新的时候，防止组件的焦点丢失
    this.hasFocus = false;
  }

  getValue = () => {
    return this.value;
  };

  getFormMode = (a) => {
    return this.options.formMode;
  };

  _bindField = (field) => {
    this.field = field;
  };

  filterData = (items) => {
    let newValue = this.value;
    var newItems = items || this.state.items;
    if (this.hasSelectOther) {
      if (this.itemsMap[newValue]) {
        this.selectOther = false;
      } else {
        if (newValue) {
          this.otherText = newValue;
          this.selectOther = true;
        } else {
          if (newValue == "") {
            this.selectOther = false;
          }
          this.otherText = null;
        }
      }
    } else {
      switch (this.options.type) {
        case "subform_radiogroup":
        case "subform_combo":
        case "radiogroup":
        case "combo": {
          if (!this.itemsMap[newValue] && !BsyUtils.isObjectEmpty(newValue)) {
            newItems.push({
              text: newValue,
              value: newValue,
            });
            this.itemsMap[newValue] = {
              text: newValue,
              value: newValue,
            };
          }
          break;
        }
        case "subform_checkboxgroup":
        case "subform_combocheck":
        case "checkboxgroup":
        case "combocheck": {
          if (!BsyUtils.isObjectEmpty(newValue)) {
            BsyUtils.forEach(newValue, (index, val) => {
              if (!this.itemsMap[val] && val) {
                newItems.push({
                  text: val,
                  value: val,
                });
                this.itemsMap[val] = {
                  text: val,
                  value: val,
                };
              }
            });
          }
          break;
        }
        default: {
          break;
        }
      }
    }

    return newItems;
  };

  getSubformRowValue = (val, row) => {
    let rowval = _.get(val, row);
    if (!rowval.rowId) {
      var id = BsyUtils.Ids24();
      rowval.rowId = id;
      rowval.id = id;
      val[row] = rowval;
    }
    return rowval;
  };

  setMemValue = function (subformMode,runFireLink) {
    let that = this;
    if (this.field) {
      switch (this.getWidgetType()) {
        case "subform": {
          let value = this.getObjectValue();

          var newLine = -1;
          _.forEach(value, (row, index) => {
            if (!row.rowId) {
              newLine = index;
              delete value[index].status;
            }
          });
          this.dataSource = value;
          this.field.setValue(value, () => {
            if (newLine > -1) {
              let val = this.getSubformRowValue(that.field.value, newLine);
              this.field.fireSubformRowLink(val.rowId, val.isCopy);
              // this.field.fireSubformRowLink(,false)
            } else {
              this.field.fireLink(subformMode);
            }
          });
          break;
        }
        case "linkquery": {
          let value = this.getValue();
          // this.field.setValue(value, null, !0);
          break;
        }
        default: {
          let value = this.getValue();
          this.field.setValue(value, null, !0);
          if(runFireLink !== false)
            this.field.fireLink();
        }
      }

      // if (this.getWidgetType() == 'subform') {
      //     let value = this.getObjectValue();

      //     var newLine = -1;
      //     _.forEach(value, (row, index) => {
      //         if (row.status == 'new') {
      //             newLine = index;
      //             delete value[index].status
      //         }
      //     })
      //     this.dataSource = value;
      //     this.field.setValue(value, () => {
      //         if (newLine > -1) {
      //             let val = _.get(that.field.value, newLine);
      //             this.field.fireSubformRowLink(val.rowId, false)
      //             // this.field.fireSubformRowLink(,false)
      //         } else {
      //             this.field.fireLink();
      //         }

      //     });

      // } else {
      //     let value = this.getValue();
      //     this.field.setValue(value, null, !0);
      //     if(!this.getWidgetType() != 'linkquery')
      //     this.field.fireLink();
      // }
    }
  };

  //给功能模块使用
  getItemsValues = () => {
    const { items } = this.state;
    var newItemsValue = [];
    switch (this.options.type) {
      case "subform_radiogroup":
      case "subform_combo":
      case "radiogroup":
      case "combo": {
        BsyUtils.forEach(items, (i, item) => {
          newItemsValue.push({ value: item.value });
        });
        break;
      }
      case "subform_checkboxgroup":
      case "subform_combocheck":
      case "checkboxgroup":
      case "combocheck": {
        BsyUtils.forEach(items, (i, item) => {
          newItemsValue.push({ value: item.value });
        });
        break;
      }
      default: {
      }
    }
    return newItemsValue;
  };

  getDefaultValue = () => {
    this.value = null;
    let items = [];
    this.itemsMap = {};
    switch (this.options.type) {
      case "subform_radiogroup":
      case "subform_combo":
      case "radiogroup":
      case "combo": {
        if (this.options.async && this.options.async.url) {
          this.value = this.options.value;
        } else {
          items = this.options.items || [
            {
              value: React.language("field.options", {
                num: 1,
              }),
              text: React.language("field.options", {
                num: 1,
              }),
            },
            {
              value: React.language("field.options", {
                num: 2,
              }),
              text: React.language("field.options", {
                num: 2,
              }),
            },
            {
              value: React.language("field.options", {
                num: 3,
              }),
              text: React.language("field.options", {
                num: 3,
              }),
            },
          ];
          let value = null;
          for (let i = 0; i < items.length; i++) {
            if (items[i].isOther) {
              this.hasSelectOther = true;
              this.otherItem = items[i];
            } else {
              this.itemsMap[items[i].value] = items[i];
            }
            if (items[i].selected) {
              if (items[i].isOther) {
                this.otherText = this.options.value || "";
                this.selectOther = true;
                value = null;
              } else {
                value = items[i].value;
              }
            }
          }
          this.value = _.isNil(this.options.value) ? value : this.options.value;
          items = this.filterData(items);
        }
        break;
      }
      case "subform_checkboxgroup":
      case "subform_combocheck":
      case "checkboxgroup":
      case "combocheck": {
        if (this.options.async && this.options.async.url) {
          this.value = this.options.value;
        } else {
          let value = [];
          items = this.options.items || [
            {
              value: React.language("field.options", {
                num: 1,
              }),
              text: React.language("field.options", {
                num: 1,
              }),
            },
            {
              value: React.language("field.options", {
                num: 2,
              }),
              text: React.language("field.options", {
                num: 2,
              }),
            },
            {
              value: React.language("field.options", {
                num: 3,
              }),
              text: React.language("field.options", {
                num: 3,
              }),
            },
          ];

          for (let i = 0; i < items.length; i++) {
            if (items[i].selected) {
              value.push(items[i].value);
            }
            this.itemsMap[items[i].value] = items[i];
          }
          this.value = _.isNil(this.options.value) ? value : this.options.value;
          items = this.filterData(items);
        }
        break;
      }
      default: {
        this.value = this.options.value;
      }
    }

    return {
      value: this.value,
      items: items,
    };
  };

  setValue = (t) => {
    _.isNil(t) ? (this.value = null) : (this.value = t);
    this.setState({
      value: this.value,
    });
  };

  componentDidMount() {
    //方便后续全局获取操作

    this._init();

    if (this.props.getContext) {
      this.props.getContext(this);
    }

    this._afterInit();
  }

  renderBtn = (widgetCls, value) => {
    return (
      <div
        className={
          "iconSelect " + (!BsyUtils.isObjectEmpty(value) ? "has-value" : "")
        }
      >
        <i className={"widget-icon " + widgetCls}></i>
        <i
          className="widget-icon icon-dingding-guide-close"
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            this.clear && this.clear(event);
          }}
        ></i>
      </div>
    );
  };

  clear = (event) => {
    event.stopPropagation();
    event.preventDefault();
    this.value = null;
    this.setState(
      {
        value: null,
      },
      () => {
        this.props.onStopEdit(this.state.value, null, this);
      }
    );
  };

  _init = () => {};

  _beforeInit = () => {
    BsyUtils.applyFunc(
      this,
      this.options.onBeforeInit,
      [this.options.value, null, this],
      !1
    );
  };
  _afterInit = () => {
    BsyUtils.applyFunc(
      this,
      this.options.onAfterInit,
      [this.options.value, null, this],
      !1
    );
  };

  getWidgetByName = (a) => {
    return this.options.resultWidgets ? this.options.resultWidgets[a] : null;
  };
  getWidgetName = () => {
    return this.options.widgetName;
  };
  getWidgetType = () => {
    return this.options.type;
  };
  // _renderStyles:function(){
  //     if(this.options.dashStyles)
  //         this.dashTheme = 'dash-custom-'+ this.options.dashStyles.theme.name;
  // }
  getNullValue = () => {
    return null;
  };
  getLinkValue = () => {
    return this.getValue();
  };
  getLinkType = () => {
    return this.getWidgetType();
  };
  getText = () => {
    return this.options.text;
  };
  setText = (a) => {
    this.options.text = a;
  };

  getFormMode = (a) => {
    return this.options.formMode;
  };
  isEnabled = () => {
    return this.options.ignoreOptAuth || this.options.enable;
  };
  setEnable = (a) => {
    this.options.enable = !!a;
    this.options.enable === !0
      ? this.element.current.classList.remove("bsy-ui-disable")
      : !["subform","separator"].includes(this.options.type) && this.element.current.classList.add("bsy-ui-disable");
  };

  getTabName = () => {
    return this.options.tab;
  };

  isVisible = () => {
    return this.options.ignoreOptAuth || this.options.visible;
  };
  setVisible = (a) => {
    console.log("--- setVisible bsy-ui-hidden ---");
    if (this.options.design) return;
    this.options.visible = !!a;
    this.options.visible === !0
      ? this.element.current.classList.remove("bsy-ui-hidden")
      : this.element.current.classList.add("bsy-ui-hidden");
  };
  getVisible = () => {
    return this.options.ignoreOptAuth || this.options.visible;
  };
  reset = () => {
    this.setValue(null);
  };
  doResize = (a) => {
    let b = this.options;
    if (a) {
      b.width = a.width;
      b.height = a.height;
    }

    // BsyUtils.isEmpty(b.width) || this.element.current.style.width = ({
    //     width: b.width
    // })
    // BsyUtils.isEmpty(b.height) || this.element.css({
    //     height: b.height
    // })
    // BsyUtils.isEmpty(b.lineHeight) || this.element.css({
    //     lineHeight: b.lineHeight
    // })
  };
  destroy = () => {
    this.element.remove();
  };
  effectStopEdit = () => {
    BsyUtils.applyFunc(this, this.options.onStopEdit, [], !1);
  };
  effectBeforeAsync = () => {
    return BsyUtils.applyFunc(this, this.options.onBeforeAsync, [], !1);
  };
  rebuild = () => {
    console.log("--- rebuild bsy-ui-hidden ---");
    this.options.cssName = this.options.baseCls + " " + this.options.widgetName;
    if (!this.isEnabled()) {
      if (!["subform","separator"].includes(this.options.type) )
        this.options.cssName += " bsy-ui-disable";
    }
    if (!this.isVisible()) {
      this.options.cssName += " bsy-ui-hidden";
    }

    if (this.options.customCls) {
      this.options.cssName += " " + this.options.customCls;
    }

    this.options.css = {};
    if (this.options.height) this.options.css.height = this.options.height;
    if (this.options.width) this.options.css.width = this.options.width;
    // this.options.css.lineHeight = this.options.lineHeight + 'px';
    // this.value = this.options.value;
    this.setState({});
  };

  checkValidate = () => {
    return !0;
  };
  fireEvent = (a, b) => {
    this.element.trigger(a, b);
  };
  getOptions = () => {
    let a = this.options;
    return {
      type: a.type,
      widgetName: a.widgetName,
      widgetNameAlias: a.widgetNameAlias ? a.widgetNameAlias : "",
      triggerEvent: a.triggerEvent,
      customCls: a.customCls,
      height: a.height,
      width: a.width,
      text: a.text,
      value: a.value,
      enable: a.enable,
      visible: a.visible,
      allowBlank: a.allowBlank,
      rely: a.rely,
      labelStyle: a.labelStyle,
      controlType: a.controlType,
      funMode: a.funMode,
      module: a.module,
      libs: a.libs,
      extendSet: a.extendSet,
    };
  };
  getInvalidateType = () => {
    return this.options.invalidateType;
  };
  setInvalidateType = (a) => {
    this.options.invalidateType = a;
  };
  getInvalidateTypeText = (a) => {
    return this.options.invalidateTypeText;
  };
  setInvalidateTypeText = (a) => {
    this.options.invalidateTypeText = a;
  };
  getNullValue = () => {
    return null;
  };
  getLinkValue = () => {
    return this.getValue();
  };
  getLinkType = () => {
    return this.getWidgetType();
  };
  getCacheValue = () => {
    return this.getValue();
  };
  setCacheValue = (t) => {
    this.setValue(t);
  };
  select = () => {
    this.oriWidget && this.oriWidget.select();
  };
  isSubformWidget = (t) => {
    return /\./.test(t);
  };
  bindWidgetEvent = (t, e) => {
    this.options[t] = e;
  };
  unbindWidgetEvent = (t) => {
    this.options[t] = null;
  };

  renderDisablePane = (value) => {
    return (
      <div
        className="bsy_form_item_disable"
        data-watermark={React.language("content.empty")}
      >
        {value}
      </div>
    );
  };
}
